import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ThemeDto from '../../../administration/dto/ThemeDto'
import AdministrationAction from '../../../administration/actions/AdministrationAction'
import AppStore from '../../../store/AppStore'
import CheckPanel from '../../../components/panel/CheckPanel'
import { getColor } from '../../../utils/ThemesUtils'
import ListComponent from '../../../components/list/ListComponent'
import DtoStation from '../../dto/DtoStation'
import { filter, flatten, isEqual, uniq } from 'lodash'
import SitesAction from '../../actions/SitesAction'
import ToastrAction from '../../../home/actions/ToastrAction'
import i18n from 'simple-react-i18n'

class ThemesTabPanel extends Component {

	shouldComponentUpdate(nextProps) {
		return !isEqual(this.props.themes, nextProps.themes) ||
			!isEqual(this.props.selectedThemes, nextProps.selectedThemes) ||
			!isEqual(this.props.selectedStations, nextProps.selectedStations) ||
			!isEqual(this.props.stations, nextProps.stations)
	}

	toggleFamily = (id) => {
		const finalSelectedThemes = (() => {
			const family = this.props.themes.find(f => f.id === id)
			const selectedThemes = this.props.selectedThemes.slice()

			const isSelected = !!selectedThemes.find(t => t.value.masterTheme === id)
			if (isSelected) {
				return selectedThemes.filter(t => t.value.masterTheme !== id)
			}
			return selectedThemes.concat(family.themes.filter(t => !t.disable).map(t => ({
				label: t.title,
				value: Object.assign({}, t)
			})))
		})()
		if (!finalSelectedThemes.length) {
			AppStore.dispatch(ToastrAction.error(i18n.error.pleaseFillLeastTheme))
		} else {
			AppStore.dispatch(AdministrationAction.selectedThemes(finalSelectedThemes))
			if (this.props.selectedStations.length) {
				const siteTypes = uniq(flatten(finalSelectedThemes.map(th =>
					th.value.siteTypes.map(t => t.type)
				)))
				const resultStations = flatten(siteTypes.map((o) => {
					return filter(this.props.stations, (b) => {
						return b.typeParameter == o
					})
				}))
				AppStore.dispatch(SitesAction.setSelectedStations(resultStations))
			}
		}
	}


	toggleTheme = theme => () => {
		const finalSelectedThemes = (() => {
			const selectedThemes = this.props.selectedThemes.slice()
			const isSelected = !!selectedThemes.find(t => t.value.id === theme.id)
			if (isSelected) {
				return selectedThemes.filter(t => t.value.id !== theme.id)
			}
			return selectedThemes.concat([{
				label: theme.title,
				value: Object.assign({}, theme)
			}])
		})()
		if (!finalSelectedThemes.length) {
			AppStore.dispatch(ToastrAction.error(i18n.error.pleaseFillLeastTheme))
		} else {
			if (this.props.selectedStations.length) {
				const siteTypes = uniq(flatten(finalSelectedThemes.map(th =>
					th.value.siteTypes.map(t => t.type)
				)))
				const resultStations = flatten(siteTypes.map((o) => {
					return filter(this.props.stations, (b) => {
						return b.typeParameter == o
					})
				}))
				AppStore.dispatch(SitesAction.setSelectedStations(resultStations))
			}
			AppStore.dispatch(AdministrationAction.selectedThemes(finalSelectedThemes))
		}
	}

	getCheckPanel = t => {
		const checked = !!this.props.selectedThemes.find(st => st.value.id === t.id)
		const f = this.props.themes.find(o => o.id === t.masterTheme)
		return (
			<CheckPanel key={ t.id } onToggleCheck={ this.toggleTheme(t, f.id) }
						backgroundColor={ () => getColor(this.props.themes, t, 1) } checked={ checked }
						className='theme-row'>
				{ this.getPanel(t, 'no-padding') }
			</CheckPanel>
		)
	}

	getPanel = (t, className = 'theme-row') => {
		return (
			<div className='row no-margin'>
				<div className={ `col s12 ${ className }` }>
					<div>
						<div className='col s2 no-padding'>
							<div className='iconeTypeResearchWrapper'>
								<img className='iconeTypeResearch circle responsive-img' src={ t.pic }/>
							</div>
						</div>
						<div className='col s10 no-padding site-type-title'>
							<b>{ t.title }</b>
						</div>
					</div>
				</div>
			</div>
		)
	}


	getContent() {
		const entities = this.props.themes.reduce((a, f) => {
			const themes = f.themes.filter(t => !t.disable).map(t => this.getCheckPanel(t))
			if (themes && themes.length) {
				const isChecked = !!this.props.selectedThemes.filter(t => t.value.masterTheme === f.id).length
				a.push({
					title: f.title,
					component: themes,
					picture: f.image,
					id: f.id,
					isChecked,
					color: `rgb(${ f.color })`
				})
			}
			return a
		}, [])
		return <ListComponent tables={ entities } generalFunction={ this.toggleFamily }/>
	}

	render() {
		return this.getContent()
	}
}

ThemesTabPanel.propTypes = {
	selectedThemes: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string,
		value: PropTypes.instanceOf(ThemeDto)
	})),
	themes: PropTypes.arrayOf(PropTypes.instanceOf(ThemeDto)),
	selectedStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation)),
	stations: PropTypes.arrayOf(PropTypes.instanceOf(DtoStation))
}

const mapStateToProps = store => {
	return {
		selectedThemes: store.AdministrationReducer.selectedThemes,
		themes: store.AdministrationReducer.themes,
		selectedStations: store.SitesReducer.selectedStations,
		stations: store.SitesReducer.stations
	}
}

export default connect(mapStateToProps)(ThemesTabPanel)



// WEBPACK FOOTER //
// ./src/sites/components/tab/ThemesTabPanel.js